// extracted by mini-css-extract-plugin
export default {"footer":"M9SngLnBv6MIK2YdpFYD","waper-logo":"ImQfD5gc0grLL1SkuK3i"};